export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MobileMenu.vue?vue&type=template&id=3759d3ac&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/Layout/Extra/MobileMenu.vue?vue&type=template&id=3759d3ac&scoped=true
// module id = 1666
// module chunks = 31